module.exports = __webpack_public_path__ + "static/media/client-3.47ea5601.png";